import React from 'react';
import { ReactComponent as RemoveIcon } from '../../Common/BootstrapIcons/close.svg';
import ColumnDefinition from '../../../infrastructure/types/DataGrid/ColumnDefinition';
import DictionaryField from '../../../types/report/DictionaryField';
import CustomIcon from '../../Common/BootstrapIcons/Custom/CustomIcon';
import iconTooltip from '../../Common/BootstrapIcons/Tooltip/IconTooltip';
import EditableText from '../../Common/EditableText/EditableText';
import dataType from '../../../infrastructure/constants/dataType';
import { mapToBasicOption } from '../../../infrastructure/helpers/html/selectOptionHelper';
import Assignment from '../../../types/functions/Assignment/Assignment';
import SelectList from '../../Common/SelectList/SelectList';
import UserDefinedFunctionParameter from '../../../types/report/UserDefinedFunctionParameter';

const dataTypeOptions = Object.values(dataType).map(mapToBasicOption);

const getDataTypeContent = (field: DictionaryField, onChange: (type: string, number: number, assignment: Assignment) => void, isReadOnly: boolean, onLockSectionClick?: (number: number) => Promise<boolean>): JSX.Element => {

    const onChangeCheckIfLocked = async (type: string, number: number, assignment: Assignment, event: React.ChangeEvent<HTMLElement>): Promise<void> => {

        const isLocked = onLockSectionClick && await onLockSectionClick(number);
        if (!isLocked) {
            onChange(type, field.number, field.assignment);
        }
        else {
            event.preventDefault();
        }
    }

    return (
        <SelectList
            className="inline-select"
            options={dataTypeOptions}
            value={field.dataType}
            onClick={async (event) => onLockSectionClick && await onLockSectionClick(field.number)}
            onChange={(type, event) => { onLockSectionClick ? onChangeCheckIfLocked(type, field.number, field.assignment, event) : onChange(type, field.number, field.assignment) }}
            disabled={isReadOnly} />
    );
};

const getColumns = (
    onNameChange: (name: string, number: number) => void,
    onDataTypeChange: (type: string, number: number, assignment: Assignment) => void,
    onBusinessDescriptionChange: (businessDescription: string, number: number) => void,
    onRemoveClick: (number: number) => void,
    isReadOnly: boolean): ColumnDefinition<UserDefinedFunctionParameter>[] => {

    let columns: ColumnDefinition<UserDefinedFunctionParameter>[] = [
        {
            header: 'Parameter Name',
            getContent: x => <EditableText disabled={isReadOnly} value={x.name} onChange={value => onNameChange(value, x.number)} multiline={false} />,
            width: '200px'
        },
        {
            header: 'Data Type',
            getContent: x => getDataTypeContent(x, onDataTypeChange, isReadOnly),
            width: '200px'
        },
        {
            header: 'Business Description',
            getContent: x => <EditableText disabled={isReadOnly} value={x.businessDescription} onChange={value => onBusinessDescriptionChange(value, x.number)} multiline={true} style={{ width: '100%', height: '60px' }} />
        },
        {
            header: '',
            getContent: x =>
                <button
                    className="custom-icon-button float-right"
                    onClick={() => onRemoveClick(x.number)}
                    disabled={isReadOnly}>
                    <CustomIcon icon={RemoveIcon} title={iconTooltip.remove} />
                </button>,
            width: '40px'
        }
    ];

    return columns;
};

export {
    getColumns
};